import React from 'react';
import ThemedIcon from '../common/ThemedIcon';
import DependantIcon from '../../images/home/dependant.svg';

const DependentCard = ({ dependentCards }) => {
  const { cardInfo, cardDirective } = dependentCards || {};
  return (
    <div className="border border-txtsecondary-shades7 rounded-12 p-4 pb-0 m-4 mb-0">
      <div className="flex justify-between w-full">
        <div className="flex flex-col flex-1 gap-1 w-3/4">
          <div className="text-txtlight font-semibold text-body-l">
            {cardInfo.heading}
          </div>
          <div className="text-body-s font-regular text-txtsecondary">
            {cardInfo.text}
          </div>
        </div>
        <div className=" w-1/4">
          <img src={cardInfo.image} className="w-24 h-24" alt="icon" />
        </div>
      </div>
      {cardDirective.elements.length > 0 && (
        <div
          className="border-t border-txtsecondary-shades7 text-primary font-semibold text-body-l mt-4 py-2 pb-4 text-center clickable flex items-center justify-center gap-2"
          onClick={() =>
            window.open(cardDirective.elements[0].redirectTo, '_blank')
          }
        >
          <ThemedIcon src={DependantIcon} />
          {cardDirective.elements[0].label}
        </div>
      )}
    </div>
  );
};

export default DependentCard;
